import * as React from 'react';
import { IgcAccordionComponent as Component } from 'igniteui-webcomponents';
import type { IgcExpansionPanelComponentEventMap } from 'igniteui-webcomponents';
import { type EventName, createComponent } from '../react-props.js';

/**
 * The Accordion is a container-based component that can house multiple expansion panels
 * and offers keyboard navigation.
 * @slot  - Renders the expansion panels inside default slot.
 * @class
 */
export const IgrAccordion = /* @__PURE__ */ createComponent({
  tagName: 'igc-accordion',
  displayName: 'IgrAccordion',
  elementClass: Component,
  react: React,
  events: {
    onOpening: 'igcOpening' as EventName<
      IgcExpansionPanelComponentEventMap['igcOpening']
    >,
    onOpened: 'igcOpened' as EventName<
      IgcExpansionPanelComponentEventMap['igcOpened']
    >,
    onClosing: 'igcClosing' as EventName<
      IgcExpansionPanelComponentEventMap['igcClosing']
    >,
    onClosed: 'igcClosed' as EventName<
      IgcExpansionPanelComponentEventMap['igcClosed']
    >,
  },
});

export type IgrAccordion = Component;

/** @deprecated Module register is no longer needed and can be removed */
export const IgrAccordionModule = Component;
